import React from "react";
import { Outlet } from "react-router-dom";
import Tabs from "../../../components/common/Tabs";

  const tabs = [
    {
      link: "/reporting/metrics_pricing/pricing",
      title: "Pricing Metrics",
    },
    {
      link: "/reporting/metrics_pricing/tenant_insurance_coverage",
      title: "Tenant Insurance Coverage",
    },
    {
      link: "/reporting/metrics_pricing/data_diagnostic",
      title: "Data Diagnostic",
    },
  ];
  
function Metrics() {
  return (
    <>
    <Tabs tabs={tabs} />
    <Outlet />
    </>
  );
}

export default Metrics;